import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionExtensionsPanel } from "@/components/admin/SubscriptionExtensionsPanel";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const Route = createFileRoute("/_admin/admin/subscription-extensions")({
  component: SubscriptionExtensionsPage,
  head: () => ({
    meta: [
      { title: "Subscription Extensions | Admin" },
      {
        name: "description",
        content: "Monitor retained meals rescheduled by Skip & Extend across all subscriptions.",
      },
    ],
  }),
});

function SubscriptionExtensionsPage() {
  const [isDemo, setIsDemo] = useState(false);

  return (
    <div className="p-4 md:p-6">
      <header className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold">Subscription Extensions</h1>
          <p className="text-sm text-muted-foreground">
            Retained meals rescheduled by “Skip &amp; Extend” — already paid, no new order or
            payment.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="ext-demo" checked={isDemo} onCheckedChange={setIsDemo} />
          <Label htmlFor="ext-demo" className="text-xs text-muted-foreground">
            Demo data
          </Label>
        </div>
      </header>

      <SubscriptionExtensionsPanel isDemo={isDemo} />
    </div>
  );
}
